import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui-kit";

const COOKIE_CONSENT_KEY = "crediking_cookie_consent";

type Consent = "accepted" | "rejected";

function readConsent(): Consent | null {
  if (typeof window === "undefined") return null;
  const v = localStorage.getItem(COOKIE_CONSENT_KEY);
  if (v === "accepted" || v === "rejected") return v;
  return null;
}

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(readConsent() == null);
  }, []);

  const save = (value: Consent) => {
    localStorage.setItem(COOKIE_CONSENT_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-[100] p-4 sm:p-6 pointer-events-none"
    >
      <div className="pointer-events-auto mx-auto max-w-3xl rounded-xl border border-border/80 bg-background/95 backdrop-blur-xl shadow-lg p-5 sm:p-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
          <div className="min-w-0 flex-1">
            <h2 className="font-display text-lg text-foreground">We use cookies</h2>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
              We use essential cookies to keep CrediKing secure and working. With your consent, we may
              also use functional and analytics cookies. See our{" "}
              <Link to="/cookies" className="text-gold hover:underline">
                Cookie Policy
              </Link>{" "}
              and{" "}
              <Link to="/privacy" className="text-gold hover:underline">
                Privacy Policy
              </Link>
              .
            </p>
          </div>
          <div className="flex shrink-0 flex-wrap gap-2 sm:justify-end">
            <Button variant="ghost" onClick={() => save("rejected")}>
              Reject non-essential
            </Button>
            <Button variant="gold" onClick={() => save("accepted")}>
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
